import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonService } from 'src/app/services/common/common.service';
import { DeleteConstant } from 'src/app/constants/message-constant';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-delete-dialogbox',
  templateUrl: './delete-dialogbox.component.html',
  styleUrls: ['./delete-dialogbox.component.scss']
})
export class DeleteDialogboxComponent {
  constructor(
    public modalService: NgbActiveModal,
    private apiUrl: ApiUrlHelper,
    public commonService: CommonService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
  ) { }

  element: string = '';
  Name: string = '';
  deleteConstant: any = [];
  userDeleteObj: any = {};
  CompanyUserDeleteObj: any = {};
  companyDeleteObj: any = {};
  collegeDeleteObj: any = {};
  collegeBatchDeleteObj: any = {};
  TechnologyDeleteObj: any = {};
  questionSetDeleteObj: any = {};
  questionDeleteObj: any = {};
  paragraphDeleteObj: any = {};
  studentResultDeleteObj:any = {};
  testDeleteObj: any = {};
  studentDeleteObj:any = {};
  jobDeleteObj: any = {};
  ApiURL: string = '';
  id: any = 0;

  ngOnInit(): void {
    this.deleteConstant = DeleteConstant;
    if (this.userDeleteObj.userId > 0) {
      this.Name = this.userDeleteObj.firstName;
      this.element = this.userDeleteObj.element;
    }
    else if (this.CompanyUserDeleteObj.userId > 0) {
      this.Name = this.CompanyUserDeleteObj.firstName;
      this.element = this.CompanyUserDeleteObj.element;
    }
    else if (this.companyDeleteObj.companyId > 0) {
      this.Name = this.companyDeleteObj.companyName;
      this.element = this.companyDeleteObj.element;
    }
    else if (this.collegeDeleteObj.collegeId > 0) {
      this.Name = this.collegeDeleteObj.collegename;
      this.element = this.collegeDeleteObj.element;
    }
    else if (this.TechnologyDeleteObj.parentTechnlogyPreferenceId > 0) {
      this.Name = this.TechnologyDeleteObj.parentTechnlogyPreferencename;
      this.element = this.TechnologyDeleteObj.element;
    }
    else if (this.TechnologyDeleteObj.childTechnlogyPreferenceId > 0) {
      this.Name = this.TechnologyDeleteObj.childTechnlogyPreferencename;
      this.element = this.TechnologyDeleteObj.element;
    }
    else if (this.collegeBatchDeleteObj.collegeBatchId > 0) {
      this.Name = this.collegeBatchDeleteObj.collegeBatchname;
      this.element = this.collegeBatchDeleteObj.element;
    }
    else if (this.questionSetDeleteObj.questionSetId > 0) {
      this.Name = this.questionSetDeleteObj.questionSetName;
      this.element = this.questionSetDeleteObj.element;
    }
    else if (this.questionDeleteObj.questionId > 0) {
      this.Name = this.questionDeleteObj.questionText;
      this.element = this.questionDeleteObj.element;
    }
    else if (this.testDeleteObj.testId > 0) {
      this.Name = this.testDeleteObj.testName;
      this.element = this.testDeleteObj.element;
    }
    else if (this.paragraphDeleteObj.paragraphId > 0) {
      this.Name = this.paragraphDeleteObj.paragraphText;
      this.element = this.paragraphDeleteObj.element;
    }
    else if (this.jobDeleteObj.jobId > 0) {
      this.Name = this.jobDeleteObj.jobName;
      this.element = this.jobDeleteObj.element;
    }
    else if(this.studentResultDeleteObj.testId > 0){
      this.Name = this.studentResultDeleteObj.studentName;
      this.element = this.studentResultDeleteObj.element;
    }
    else if(this.studentDeleteObj.studentId > 0){
      this.Name = this.studentDeleteObj.studentName;
      this.element = this.studentDeleteObj.element;
    }
  }

  onDelete() {
    if (this.userDeleteObj.userId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.user.DeleteUser.replace('{id}', this.userDeleteObj.userId.toString());
      this.id = this.userDeleteObj.userId;
    }
    else if (this.CompanyUserDeleteObj.userId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.companyUser.DeleteCompanyUser.replace('{id}', this.CompanyUserDeleteObj.userId.toString());
      this.id = this.CompanyUserDeleteObj.userId;
    }
    else if (this.companyDeleteObj.companyId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.company.DeleteCompany.replace('{id}', this.companyDeleteObj.companyId.toString());
      this.id = this.companyDeleteObj.companyId;
    }
    else if (this.collegeDeleteObj.collegeId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.college.DeleteCollege.replace('{id}', this.collegeDeleteObj.collegeId.toString());
      this.id = this.collegeDeleteObj.collegeId;
    }
    else if (this.collegeBatchDeleteObj.collegeBatchId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.collageBatch.DeleteCollegeBatch.replace('{id}', this.collegeBatchDeleteObj.collegeBatchId.toString());
      this.id = this.collegeBatchDeleteObj.collegeBatchId;
    }
    else if (this.TechnologyDeleteObj.parentTechnlogyPreferenceId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.ParentTechnologyPreferences.DeleteTechnlogyPreference.replace('{id}', this.TechnologyDeleteObj.parentTechnlogyPreferenceId.toString());
      this.id = this.TechnologyDeleteObj.parentTechnlogyPreferenceId;
    }
    else if (this.TechnologyDeleteObj.childTechnlogyPreferenceId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.ChildTechnologyPreferences.DeleteTechnlogyPreference.replace('{id}', this.TechnologyDeleteObj.childTechnlogyPreferenceId.toString());
      this.id = this.TechnologyDeleteObj.childTechnlogyPreferenceId;
    }
    else if (this.questionSetDeleteObj.questionSetId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.QuestionSet.DeleteQuestionSet.replace('{id}', this.questionSetDeleteObj.questionSetId.toString());
      this.id = this.questionSetDeleteObj.questionSetId;
    }
    else if (this.questionDeleteObj.questionId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.question.DeleteQuestion.replace('{id}', this.questionDeleteObj.questionId.toString());
      this.id = this.questionDeleteObj.questionId;
    }
    else if (this.testDeleteObj.testId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.test.DeleteTest.replace('{id}', this.testDeleteObj.testId.toString());
      this.id = this.testDeleteObj.testId;
    }
    else if (this.paragraphDeleteObj.paragraphId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.question.DeleteParagraphId.replace('{id}', this.paragraphDeleteObj.paragraphId.toString());
      this.id = this.paragraphDeleteObj.paragraphId;
    }
    else if (this.jobDeleteObj.jobId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.job.DeleteJob.replace('{id}', this.jobDeleteObj.jobId.toString());
      this.id = this.jobDeleteObj.jobId;
    }
    else if( this.studentResultDeleteObj.testId > 0){
      this.ApiURL = this.apiUrl.apiUrl.test.DeleteStudentResult.replace("{id}", this.studentResultDeleteObj.testId.toString());
      this.id = this.studentResultDeleteObj.testId;
    }
    else if(this.studentDeleteObj.studentId > 0){
      this.ApiURL = this.apiUrl.apiUrl.student.DeleteStudent.replace("{id}", this.studentDeleteObj.studentId.toString());
    }
    this.spinner.show();
    this.commonService.doDelete(this.ApiURL, this.id).pipe().subscribe({
      next: (data) => {  
        if (data.success) {
          this.toastr.success(data.message)
          this.spinner.hide();
          this.modalService.close('delete');
        }
        else {
          this.toastr.error(data.message)
          this.spinner.hide();
          this.modalService.close('delete'); 
        }
      },
      error: (er) => {
        console.error(er)
      }
    });
  }
}